// extracted by mini-css-extract-plugin
export default {"sidebar":"styles__sidebar--a486e2d8001cb83e023e","visible":"styles__visible--a573a30b5f3d25e69385","close":"styles__close--bc0199703923db725bfb"};